import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { CategoryAssignmentListCard } from './components/CategoryAssignmentListCard';
import { CategoryDeleteCard } from './components/CategoryDeleteCard';
import { CategoryDetailsCard } from './components/CategoryDetailsCard';

export function CategoryDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const categoryQueryResults = useQuery({
        queryKey: ['category', id],
        queryFn: () => Api.Categories.Category.getCategory(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={categoryQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <CategoryDetailsCard category={data} />

                            <CategoryAssignmentListCard
                                category={data}
                                refetch={categoryQueryResults.refetch}
                            />

                            {!data.assignments.length && (
                                <Can I="delete" a="Category">
                                    <CategoryDeleteCard category={data} />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
